import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { createWebExpense } from '../api/billing.api';
import type { CreateWebExpensePayload } from '../types/billing.types';

export function useCreateWebExpense(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: CreateWebExpensePayload) => createWebExpense(payload),
    onSuccess: () => {
      void refreshRelatedData('billingEntry');
      toast.success('Expense saved');
      onSuccess?.();
    },
    onError: (error) => showApiErrorToast(error, 'Could not save the expense'),
  });
}
